/*
  Björn Bites: gentle reveal-on-scroll for elements with [data-bb-reveal].
  Content is visible by default; the class is only added when JS runs and motion is allowed.
*/
(() => {
  if (window.bbRevealReady) return;
  window.bbRevealReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;

  document.documentElement.classList.add('bb-js-reveal');
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const watch = (root = document) => {
    root.querySelectorAll('[data-bb-reveal]:not(.is-visible)').forEach((el, i) => {
      el.style.setProperty('--bb-reveal-delay', `${Math.min(i % 4, 3) * 70}ms`);
      io.observe(el);
    });
  };

  watch();
  // Safety net: never leave content hidden.
  setTimeout(() => document.querySelectorAll('[data-bb-reveal]').forEach((el) => el.classList.add('is-visible')), 3500);
})();
